ui.selector = function(){
	ui.readySelectorBloque(
		null,
		function(jq){
			//inicialización de bloques de selector
			var datos = nbf.extraerDatos(jq);
			var jqInfo = jq.find(">.selectorInfo").eq(0);
			var jqInput = jq.find(">.selectorVal").eq(0);
			var selector = new nbf.selector.Selector(datos.cls,datos.prop,null,datos.nav,datos.edit?true:false,datos.mult,jqInfo,jqInput);
			if(jq.hasClass("selectorBloqueDeshabilitado"))
				selector.deshabilitar(true);
			
			var jqToolbar = jq.find(">.selectorToolbar");
			jqToolbar.find(".abrir").click(
				function(ev){
					ev.preventDefault();
					selector.actualizarNavegacion();
				}
			);
			jqToolbar.find(".vaciar").click(
				function(ev){
					ev.preventDefault();
					selector.vaciarValor();
				}
			);
		}
	);

	ui.readySelectorBloque(
		".selectorBloqueObjetos",
		function(jq){
			var selector = nbf.selector.obtener(jq);
			selector.compararItemsValor = function(a,b){
				if(selector.propiedades.pk){ //tiene clave primaria definida
					//vamos comparando valor a valor, si todos son iguales devolvemos true
					for(var i=0;i<selector.propiedades.pk.length;i++){
						if(a[selector.propiedades.pk[i]]!=b[selector.propiedades.pk[i]])
							return false;
					}
					return true;
				}else if(selector.propiedades.mult) //es múltiple: concateno si no es idéntico
					return (nbf.toJSON(a)==nbf.toJSON(b));
				else //no es múltiple: siempre sobreescribo
					return true;
			};

			jq.find(".selectorToolbar").each(
				function(){
					$(this).find(".copiar").click(
						function(ev){
							ev.preventDefault();
							if(!selector.deshabilitado()){
								var key = nbf.toJSON([selector.claseSelector,selector.propiedades]);
								localStorage[key] = nbf.toJSON(selector.valor);
								var btn = $(this);
								btn.addClass("copiarOk");
								nbf.lanzar(
									1000,
									function(){
										btn.removeClass("copiarOk");
									}
								);
							}
						}
					);

					$(this).find(".pegar").click(
						function(ev){
							ev.preventDefault();
							if(!selector.deshabilitado()){
								var key = nbf.toJSON([selector.claseSelector,selector.propiedades]);
								if(localStorage[key])
									selector.asignarValor(nbf.parseJSON(localStorage[key]));
							}
						}
					);
				}
			);
		}
	);
	
	//todas las páginas de selector
	ui.readySelectorPagina(
		null,
		function(jq){
			var sel = nbf.selector.obtener(jq);
			if(!sel.atrasNavegacionAplica()){
				jq.find(".btnVolver").remove();
			}
			
			//botones de cancelar y cerrar
			jq.find(".btnCerrar, .btnCancelar").click(
				function(ev){
					ev.preventDefault();
					nbf.selector.obtener($(this)).cerrarNavegacion();
				}	
			);
			
			//todos los enlaces dentro de un selector con el href="?a=x&b=y" afectan a la navegación del selector
			jq.find("a[href^=\"?\"]").click(
				function(ev){
					ev.preventDefault();
					if($(this).closest(".toolbar").size()==0) //no debe estar dentro de un toolbar
						sel.asignarNavegacion(nbf.url.parseUrlParams($(this).attr("href").replace(/\?/,"")));
				}
			);
			
			//boton de volver
			jq.find(".btnVolver").click(
				function(ev){
					ev.preventDefault();
					nbf.selector.obtener($(this)).atrasNavegacion();
				}
			);
			
			jq.find(".toolbarListado .anadirSeleccion").click(
				function(ev){
					ev.preventDefault();
					var items = ui.listado.obtenerItemsSeleccionados(jq.find(".listado"));
					if(items.length>0)
						sel.anadirItemsValor(items);
					else
						ui.popup.crearAlerta("Debes seleccionar al menos un elemento del listado");
				}
			);
		}
	);
		
	//selector de color
	ui.readySelectorPagina(
		".paginaSelectorColor",
		function(jq){
			jq.find(".paletaColores a, .paginaSelectorColor .primarios a").click(
				function(){
					nbf.selector.jqPaginaSelector($(this)).find(".selColorActivoTxt").val(nbf.extraerDatos($(this)));
				}
			);
			
			jq.find(".btnGuardar").click(
				function(){
					var valor = nbf.selector.jqPaginaSelector($(this)).find(".selColorActivoTxt").val();
					nbf.selector.obtener($(this)).asignarNavegacion({"color":valor});
				}
			);
		}
	);
	
	ui.readySelectorInfo(
		".selectorBloqueFecha,.selectorBloqueFechaHora,.selectorBloqueFechaRango",
		function(jq){
			jq.find(".txtFecha").each(
				function(){
					$(this).mask($(this).attr("data-mask"));
				}
			);
			jq.find(".txtFecha").blur(
				function(){
					var input = $(this);
					var bloque = input.closest(".selectorBloque");
					var formato = input.attr("data-formato");
					var sel = nbf.selector.obtener(input);
					var rango = input.val().split(" - ");
					if(rango.length==2){
						var fecha1 = nbf.str.textoAFecha(rango[0],formato);
						var fecha2 = nbf.str.textoAFecha(rango[1],formato);
						if(fecha1 && fecha2)
							sel.asignarValor([fecha1,fecha2]);
						else
							input.addClass("txtFechaErr");
					}else{
						var fecha = nbf.str.textoAFecha(input.val(),formato);
						if(fecha)
							sel.asignarValor(fecha);
						else
							input.addClass("txtFechaErr");
					}
				}
			);
		}
	);
	
	ui.readySelectorInfo(
		".selectorBloqueObjetoBaseConjunto",
		function(jq){
			var listado = jq.find(".listadoInner");
			var bloque = jq.closest(".selectorBloque");
			if(listado.height()>jq.height()+5){
				bloque.addClass("selectorBloqueObjetoBaseConjuntoDesp");
				$("<a />").attr("href","#").addClass("btnDesp").click(
					function(ev){
						ev.preventDefault();
						ev.stopPropagation();
						bloque.toggleClass("selectorBloqueObjetoBaseConjuntoDespOn");
					}
				).prependTo(listado);
			}else
				bloque.removeClass("selectorBloqueObjetoBaseConjuntoDesp selectorBloqueObjetoBaseConjuntoDespOn");
		}
	);
	
	//selector de fecha/hora
	ui.readySelectorPagina(
		".paginaSelectorFecha",
		function(jq){
			var selector = nbf.selector.obtener(jq);
			jq.find(".calendarioBloque .mes .btn").click(
				function(ev){
					ev.preventDefault();
					var anyo = parseInt(jq.find(".listaAnyos").val());
					var mes = parseInt(jq.find(".listaMeses").val());
					if($(this).hasClass("btnCalendarioAnt"))
						mes = mes-1;
					else
						mes = mes+1;
					selector.asignarNavegacion({"mes":mes,"anyo":anyo});
				}
			);
			jq.find(".calendarioBloque .anyo .btn").click(
				function(ev){
					ev.preventDefault();
					var anyo = parseInt(jq.find(".listaAnyos").val());
					if($(this).is(".btnCalendarioAnt"))
						anyo = anyo-1;
					else
						anyo = anyo+1;
					selector.asignarNavegacion({"anyo":anyo});
				}
			);
			jq.find(".calendarioBloque .dia a").click(
				function(ev){
					ev.preventDefault();
					var dia = $(this).closest(".dia");
					var fecha = nbf.extraerDatos(dia);
					if(jq.find(".horaBloque").size()>0){
						dia.closest(".calendario").find(".dia").removeClass("diaSel");
						dia.addClass("diaSel");
					}else
						selector.asignarNavegacion({"fecha":fecha});
				}
			);
			jq.find(".listaMeses,.listaAnyos").change(
				function(ev){
					ev.preventDefault();
					var nav = {};
					if($(this).hasClass("listaMeses"))
						nav.mes = $(this).val();
					else
						nav.anyo = $(this).val();
					selector.asignarNavegacion(nav);
				}
			);
			
			jq.find(".btns .btnGuardar").click(
				function(ev){
					ev.preventDefault();
					var nav = {};
					nav.fecha = nbf.extraerDatos(jq.find(".diaSel"));
					nav.hora = jq.find(".selHora").val()+":"+jq.find(".selMinuto").val();
					selector.asignarNavegacion(nav);
				}
			);
		}
	);
	
	//submit de formularios en selector objeto base
	ui.ready(
		".paginaSelectorObjetoBase form.formularioListado",
		function(jq){
			jq.submit(
				function(ev){
					ev.stopPropagation(); //si hubiera forms anidados, evitamos que se submiteen
					ev.preventDefault();
					var selector = nbf.selector.obtener($(this));
					var datos = $(this).serializeArray();
					selector.asignarNavegacion(nbf.parseFormVals(datos));					
				}
			);
		}
	);
	
	//selector objeto base
	ui.readySelectorPagina(
		".paginaSelectorObjeto",
		function(jq){
			var formu = jq.find(".formulario").eq(0);
			var selector = nbf.selector.obtener(jq);
			//submit del formulario
			formu.find(".guardar").click(
				function(ev){
					ev.preventDefault();
					var valores = ui.form.obtenerValores(formu);
					nbf.ejecutar(
						selector.claseSelector+"::ajaxValidarValores",
						[valores,selector.propiedades,selector.navegacion,selector.valor],
						function(respuesta){
							if(respuesta.status=="ok"){
								if(selector.navegacion.selObjEdit){
									selector.valor[selector.navegacion.selObjEditPos] = respuesta.valores;
									selector.asignarValor(selector.valor);
								}else
									selector.anadirItemValor(respuesta.valores);
							}else{
								if(respuesta.validacion)
									ui.form.aplicarRespuestaValidacion(formu,respuesta.validacion);
								else
									ui.popup.crearAlertaRespuesta(respuesta);
							}
						}
					);
				}
			);
		}
	);
	
	//todos los infos de selector
	ui.readySelectorInfo(
		null,
		function(jq){
			//boton quitar elemento
			jq.find(".toolbar .quitar").click(
				function(ev){
					ev.preventDefault();
					var sel = nbf.selector.obtener($(this));
					if(sel){
						if($.isArray(sel.valor)){
							var pos = $(this).closest("li,tr").prevAll().size();
							sel.eliminarItemPos(pos);							
						}
					}
				}
			);
			
			//búsqueda rápida
			var inputBus = jq.find("input.objBaseBus");
			if(inputBus.size()>0){
				inputBus.keyup(
					function(ev){
						var codeK = ev.keyCode || ev.which;
						if(codeK==9 || codeK==13) //con el tab/enter salimos
							return;
						if(codeK==40 || codeK==38){ //flechas
							var bloque = inputBus.parent().find(".bloqueBusquedaRapida");
							if(bloque.size()>0){
								var h = bloque.find(".itemHover");
								if(codeK==40){ //abajo
									if(h.size()>0)
										h.removeClass("itemHover").next().addClass("itemHover");
									else
										bloque.find(".item:first").addClass("itemHover");
								}else if(codeK==38){ //arriba
									if(h.size()>0)
										h.removeClass("itemHover").prev().addClass("itemHover");
									else
										bloque.find(".item:last").addClass("itemHover");
								}
							}
						}else{
							var tLanz = nbf.lanzar(
								500,
								function(){
									ev.preventDefault();
									var sel = nbf.selector.obtener(inputBus);
									nbf.ejecutar(
										sel.claseSelector+"::ajaxNavegacion",
										[sel.propiedades,{"q":inputBus.val()},sel.valor],
										function(respuesta){
											if(respuesta.status=="ok"){
												inputBus.parent().find(".bloqueBusquedaRapida").remove();
												var lista = $(respuesta.html).find(".listadoInner").last();
												var bloque = $("<div />").append(lista).addClass("bloqueBusquedaRapida");
												inputBus.before(bloque);
												bloque.find(".item").hoverClass("itemHover");
												
												bloque.mousedown(
													function(ev){
														ev.preventDefault();
														ev.stopPropagation();
													}
												);	
												
												bloque.find("a[href^=\"?\"]").click(
													function(ev){
														ev.preventDefault();
														ev.stopPropagation();
														sel.asignarNavegacion(
															nbf.url.parseUrlParams($(this).attr("href").replace(/\?/,"")),
															true,
															function(){
																sel.navegacion = {};
															}
														);
														bloque.remove();
													}
												);
												
												bloque.find(".item").click(
													function(ev){
														ev.preventDefault();
														ev.stopPropagation();
														var targ = $(ev.target);
														if(!targ.is("a") && targ.closest("a").size()==0)
															$(this).find("a[href^=\"?\"]").eq(0).click();
													}
												);
											}
										}
									);
								}
							);
							inputBus.data("tt",tLanz);
						}
					}
				).keydown(
					function(ev){
						var codeK = ev.keyCode || ev.which;
						if(codeK==13){ //intro
							ev.preventDefault();
							var bloque = inputBus.parent().find(".bloqueBusquedaRapida");
							if(bloque.size()>0){
								var h = bloque.find(".itemHover");
								//si solo hay un item, no hay nada seleccionado y ha pulsado en intro confirmamos ese
								if(h.size()==0 && bloque.find(".item").size()==1)
									h = bloque.find(".item:first");
								if(h.size()>0){
									h.click();
									inputBus.blur();
								}
							}
						}
					}
				).blur(
					function(ev){
						inputBus.parent().find(".bloqueBusquedaRapida").hide();
						if(inputBus.data("tt"))
							clearTimeout(inputBus.data("tt"));
					}
				).focus(
					function(ev){
						inputBus.parent().find(".bloqueBusquedaRapida").show();
					}
				);
			}
			
			//listado ordenable
			var listadoOrdenable = jq.find(".listadoOrdenable");
			if(listadoOrdenable.size()>0 && jq.closest(".selectorBloqueSoloLectura").size()==0){
				var p=0;
				var l = listadoOrdenable.find("ul,tbody").eq(0);
				l.find("> li,> tr").each(
					function(){
						$(this).data("p",p);
						p++;
					}
				);
				//listado ordenable				
				ui.initJQueryUI(
					function(){
						l.sortable(
							{
								forcePlaceholderSize: true,
								update:function(event,ui){
									var sel = nbf.selector.obtener(ui.item);
									var pos1 = ui.item.data("p");
									var pos2 = ui.item.prevAll().size();
									
									var dato = sel.valor.splice(pos1,1)[0];
									sel.valor.splice(pos2,0,dato);
									sel.asignarValor(sel.valor);
								}
							}
						);
					}
				);
			}
		}
	);
	
	ui.readySelectorInfo(
		".selectorBloqueObjetos",
		function(jq){
			var sel = nbf.selector.obtener(jq);
			jq.find(".toolbar .editar,.toolbar .duplicar").click(
				function(ev){
					ev.preventDefault();
					var pos = $(this).closest(".item").prevAll().size();
					sel.navegacion = {"valores":sel.valor[pos]};
					if($(this).hasClass("editar")){
						//marcamos en la navegación la posición que estamos editando
						sel.navegacion.selObjEdit = true;
						sel.navegacion.selObjEditPos = pos;
					}
					sel.actualizarNavegacion();
				}
			);
			
			//detectamos cambios en campos editables para actualizar el valor
			var cambioCampo = function(jqCampo){
				var pos = jqCampo.closest(".item").prevAll().size();
				sel.valor[pos][jqCampo.attr("name")] = jqCampo.val();
				sel.asignarValor(sel.valor);
			};
			
			var cambioCampoEv = function(){
				cambioCampo($(this));
			};
			
			var jqListado = jq.find(".listado"); 
			jqListado.find("input[type=text],input[type=password],textarea").blur(cambioCampoEv);
			jqListado.find("input[type=checkbox],input[type=radio]").click(cambioCampoEv);
			jqListado.find("select").change(cambioCampoEv);
			jqListado.find(".selectorBloque .selectorVal").each(
				function(){
					var jqCampo = $(this);
					nbf.selector.obtener(jqCampo).change(
						function(selector){
							cambioCampo(jqCampo);
						}
					);
				}
			);
		}
	);
	
	ui.ready(
		"body",
		function(jq){
			jq.click(
				function(ev){
					if(jq.hasClass("backinlineFrame") && $(ev.target).closest(".inlineNavegacion").size()==0){
						jq.find(".inlineNavegacion").each(
							function(){
								var sel = nbf.selector.obtener($(this));
								sel.ocultarNavegacion();
							}
						);
					}
				}
			);
		}
	);
	
	return {};
}();
